'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const designSystem = require('@zapier/design-system');
const clsx = require('clsx');
const React = require('react');
const reactAria = require('react-aria');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const popover = "_popover_wo9mi_1";
const popoverContent = "_popover-content_wo9mi_18";
const dialog = "_dialog_wo9mi_34";
const closeButton = "_close-button_wo9mi_38";
const popoverHeaderLayout = "_popover-header-layout_wo9mi_49";
const popoverContentScrollContainer = "_popover-content-scroll-container_wo9mi_57";
const styles = {
	popover: popover,
	popoverContent: popoverContent,
	dialog: dialog,
	closeButton: closeButton,
	popoverHeaderLayout: popoverHeaderLayout,
	popoverContentScrollContainer: popoverContentScrollContainer
};

const Popover = ({ children, color = "dark", placement = "bottom", isOpen, onOpenChange, shouldCloseOnInteractOutside, triggerRef, title, className }) => {
  const ref = React.useRef(null);
  const { buttonProps } = reactAria.useButton({ onPress: () => onOpenChange && onOpenChange(false) }, ref);
  return React__default.default.createElement(
    reactAriaComponents.Popover,
    { className: clsx__default.default(styles.popover, className), "data-color": color, triggerRef, placement, shouldCloseOnInteractOutside, isOpen, onOpenChange },
    React__default.default.createElement(
      reactAriaComponents.Dialog,
      { className: styles.dialog },
      React__default.default.createElement(
        designSystem.Text,
        { type: "SmallPrint3", color: "GrayWarm1" },
        React__default.default.createElement(
          "div",
          { className: styles.popoverHeaderLayout },
          React__default.default.createElement(designSystem.Text, { type: "SmallPrint2", color: color === "dark" ? "BrandLavender" : "UiPrimaryStronger", tag: "div" }, title),
          React__default.default.createElement(
            "button",
            Object.assign({ ref }, buttonProps, { className: styles.closeButton, type: "button" }),
            React__default.default.createElement(designSystem.Icon, { isBlock: true, name: "formX", size: 16, color: color === "dark" ? "GrayWarm1" : "GrayWarm10" })
          )
        ),
        React__default.default.createElement(
          "div",
          { className: styles.popoverContentScrollContainer },
          React__default.default.createElement("div", { className: styles.popoverContent, "data-color": color }, children)
        )
      )
    )
  );
};

exports.Popover = Popover;
//# sourceMappingURL=Popover.cjs.js.map
